export default __webpack_public_path__ + "static/media/container_bg.087e8457.png";